import { SubscriptionProductServiceDTO } from '../types.js'

export class SubscriptionProductService {
    readonly data: SubscriptionProductServiceDTO
    readonly currencySymbol: string

    constructor(service: SubscriptionProductServiceDTO, currencySymbol: string) {
        this.data = service
        this.currencySymbol = currencySymbol
    }

    get discountAffectsVat() {
        return this.type !== 'TRADE_IN'
    }

    get type() {
        return this.data.service?.type
    }

    get name() {
        return this.data.service?.translation?.name || this.data.service!.sku
    }

    get discountNumber() {
        return this.data.discount
    }
}
